import React from "react";
import styled from "styled-components";
import "react-multi-carousel/lib/styles.css";
import { BackQuickLinkWrapper, QuickLinksWrapper } from "../../List/styles";
import { chatActions } from "../../../../_actions";
import { connect } from "react-redux";
import { quickLinkTypes } from "../../List/quickLinkTypes";
import ListFloorplans from "./Components/List.Floorplan";
import UnitListFloorplans from "./Components/UnitList.Floorplan";
import { useWindowSize } from "../../Utility/hooks";
import TextQuickLinks from "../../Quicklinks/Text.Quicklinks";
import { language, translate } from "../../../../_helpers/general.helper";

const ListFloorplansWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: white;
  position: fixed;
  top: 60px;
  z-index: 10000;
  overflow: hidden;

  .back-button {
    width: 180px !important;
  }

  .BackQuickLinkWrapper {
    padding: 0px 20px;
  }

  .BackQuickLinkText {
    width: 170px;
  }

  .QuickLinksWrapper {
    margin-left: 20px;
    margin-right: 20px;
    padding: 0;
  }

  .CustomOrAnyQuickLinkText {
    width: 200px;
  }

  .QuickLinkText {
    width: 170px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    .QuickLinkText {
      width: 200px;
    }

    .QuickLinksWrapper {
      margin-left: 40px;
      margin-right: 40px;
      padding: 0;
    }

    .BackQuickLinkWrapper {
      padding: 0px 45px;

      .BackQuickLinkText {
        width: 200px;
      }
    }

    .BackQuickLinkText {
      width: 205px !important;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    height: calc(100% - 90px);
    width: 1300px;
    top: 45px;
    border-radius: 30px;
    align-items: center;
    justify-content: center;

    .QuickLinksWrapper {
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background: white;
      z-index: 1;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
  }

  @media screen and (min-height: 900px) and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    top: 96px;
    height: calc(100% - 200px);
  }

  .floorplan-terms {
    height: 48px;
    background: #FAFAFA;
    display:flex;
    justify-content:center;
    align-items: center;
    color:#263B67;
    font-family: "DM Sans";
    font-size: 14px;
    font-weight: 500;
    z-index:100;

    & span {
    font-weight: 700;
    margin-right: 5px;
    }
      @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) { 
         position:relative;
         top: 75px;
      }
  }
`;

const DisclaimerPrice = styled.div`
  width: 401px;
  height: 20px;
  color: var(--Primary-Blue, #42accd);
  text-align: center;
  font-family: "Dm sans";
  font-size: 8px;
  font-weight: 600;
  letter-spacing: 0.16px;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;

  &.hide-disclaimer {
    display: none;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    width: 100%;
  }
`;

function Floorplans({ data, quicklinks, floorplan, lang, tid}) {
  const { width } = useWindowSize();
  
  const isStudent = data[0].bot_type === "Student";

  let wordEn;
  let wordEs;
  if(isStudent) {
  let inputString = data[0].term[0].name;
  const regexEn = /<en>(.*?)<\/en>/;
  const regexEs = /<es>(.*?)<\/es>/;

  inputString.match(regexEn) ? wordEn = inputString.match(regexEn)[1] : wordEn = data[0].term[0].name;
  inputString.match(regexEs) ? wordEs = inputString.match(regexEs)[1] : wordEs = data[0].term[0].name;   
  }

  return (
    <ListFloorplansWrapper>
        {data[0].bot_type === "Student" && !floorplan && <div className="floorplan-terms"><span>{translate("Term:", language(tid))}</span>{lang === "English" ? wordEn : wordEs}</div>}
      {floorplan ? (
        <UnitListFloorplans></UnitListFloorplans>
      ) : (
        <ListFloorplans data={data}></ListFloorplans>
      )}
      {!floorplan && (
        <QuickLinksWrapper className="QuickLinksWrapper" specials>
          <DisclaimerPrice className={floorplan && "hide-disclaimer"}>
            {data && data.length && data[0].disclaimer}
          </DisclaimerPrice>
          {quicklinks
            .filter((ql) =>
              width < 1024 ? ql.subType && ql.subType !== "back" : true
            )
            .map((quickLink, key) => {
              const type = quickLink.type || "text";
              const QuickLinkType = quickLinkTypes[type];

              return (
                <QuickLinkType
                  key={`quicklinks-${key}`}
                  data={quickLink}
                  specials
                />
              );
            })}

          {!!data[0].nearby_properties && data[0].nearby_properties > 0 && (
            <TextQuickLinks
              key="quicklinks-test"
              data={{
                text: data[0].nearby_properties_text,
                value: "NearbyProperties-NearbyPropertiesConversation",
                subType: "text",
                gaEvent: "Floorplans-Pick-FloorplanConversation",
              }}
              specials
            />
          )}
        </QuickLinksWrapper>
      )}
      {!floorplan && width < 1024 && (
        <BackQuickLinkWrapper className="BackQuickLinkWrapper" specials>
          {quicklinks
            .filter((ql) => ql.subType && ql.subType === "back")
            .map((quickLink, key) => {
              const type = quickLink.type || "text";
              const QuickLinkType = quickLinkTypes[type];
              return (
                <QuickLinkType
                  key={`quickLinks-${key}`}
                  data={quickLink}
                  specials
                  className="back-button"
                />
              );
            })}
        </BackQuickLinkWrapper>
      )}
    </ListFloorplansWrapper>
  );
}

const mapStateToProps = (state) => ({
  quicklinks: state.chat.quicklinks,
  floorplan: state.floorplan.selectedFloorplan,
  lang: state.settings.language,
  tid: state.settings.tid,
});

const mapDispatchToProps = {
  send: chatActions.send,
};

export default connect(mapStateToProps, mapDispatchToProps)(Floorplans);
